"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_TOOLTIP_OPTIONS = exports.DEFAULT_TITLE_OPTIONS = exports.DEFAULT_SUBTITLE_OPTIONS = exports.DEFAULT_SCALE_OPTIONS = exports.DEFAULT_FOOTER_OPTIONS = exports.DEFAULT_DROPDOWN_OPTIONS = exports.DEFAULT_COLOR_SCALE = void 0;
const ChartWrapper_1 = require("../../components/ChartWrapper");
const colors_1 = require("../../utilities/colors");
const constants_1 = require("../../utilities/constants");
exports.DEFAULT_COLOR_SCALE = colors_1.SEQUENTIAL_COLOR_RANGES['teal-6-bin'];
exports.DEFAULT_DROPDOWN_OPTIONS = {
  enabled: true,
  selectedItem: undefined,
  show: true,
  sort: true,
  type: undefined
};
exports.DEFAULT_FOOTER_OPTIONS = {
  fontSize: constants_1.DEFAULT_FONT_SIZE,
  footnotes: undefined,
  show: true,
  sources: undefined
};
exports.DEFAULT_SCALE_OPTIONS = {
  centeredScale: false,
  colorScale: exports.DEFAULT_COLOR_SCALE,
  floatingScale: false,
  fontColor: undefined,
  fontSize: constants_1.DEFAULT_FONT_SIZE,
  height: 10,
  reverseColorOrder: false,
  values: [],
  width: undefined,
  x: undefined,
  y: undefined
};
exports.DEFAULT_SUBTITLE_OPTIONS = {
  fontSize: ChartWrapper_1.DEFAULT_SUBTITLE_FONT_SIZE,
  text: ''
};
exports.DEFAULT_TITLE_OPTIONS = {
  fontSize: ChartWrapper_1.DEFAULT_TITLE_FONT_SIZE,
  text: ''
};
exports.DEFAULT_TOOLTIP_OPTIONS = {
  color: 'scale-darkest',
  decimals: undefined,
  show: true,
  showSubtitle: true
};